module.exports = __webpack_public_path__ + "images/jorge-pereira.0cb36d9885da9e32e0f77f082a2b15a2.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/jorge-pereira.jpeg
// module id = 1028
// module chunks = 0